import { Component, NgZone, OnInit } from '@angular/core';
import { SpinnerService } from './services/spinner/spinner.service';
import { Observable, ReplaySubject } from 'rxjs';
declare global {
  interface Window {
    // Web3: any;
    ethereum:any;
  }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title: string = 'trainer-hub';
  showSpinner: boolean = false;
  // showSpinner$: Observable<boolean>;

  constructor(
    private spinnerService: SpinnerService,
    private ngZone: NgZone
  ) {
  }

  ngOnInit(): void {
    // this.showSpinner$ = this.spinnerService.showSpinner$
    this.spinnerService.showSpinner$.subscribe(v => {
      setTimeout(() => {
        // this.showSpinner = v
        // console.log(' this.showSpinner', this.showSpinner)
        this.ngZone.run(() => this.showSpinner = v);
      });
    });
  }
}
